
import React from 'react';
import { Category, Question } from '@/types/assessment';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers';
import { QuestionItem } from '../QuestionItem';

interface QuestionsDragContainerProps {
  selectedCategory: Category;
  categories: Category[];
  setCategories: React.Dispatch<React.SetStateAction<Category[]>>;
  onDragEnd: (event: DragEndEvent) => void;
  onUpdateQuestion: (categoryId: string, questionId: string, updates: Partial<Question>) => void;
  onUpdateAnswer: (categoryId: string, questionId: string, answerId: string, updates: Partial<any>) => void;
  onAddAnswer: (categoryId: string, questionId: string) => void;
  onEditQuestion: (questionId: string) => void;
  onDeleteQuestion: (categoryId: string, questionId: string) => void;
  onToggleQuestionStatus: (categoryId: string, questionId: string) => void;
  isMaturityModel?: boolean;
}

export function QuestionsDragContainer({
  selectedCategory,
  onDragEnd,
  onUpdateQuestion,
  onUpdateAnswer,
  onAddAnswer,
  onEditQuestion,
  onDeleteQuestion,
  onToggleQuestionStatus,
  isMaturityModel = false
}: QuestionsDragContainerProps) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
    >
      <SortableContext
        items={selectedCategory.questions.map(question => question.id)}
        strategy={verticalListSortingStrategy}
      >
        {selectedCategory.questions.map((question) => (
          <QuestionItem
            key={question.id}
            categoryId={selectedCategory.id}
            question={question}
            onUpdateQuestion={onUpdateQuestion}
            onUpdateAnswer={onUpdateAnswer}
            onAddAnswer={onAddAnswer}
            onEditQuestion={onEditQuestion}
            onDeleteQuestion={onDeleteQuestion}
            onToggleQuestionStatus={onToggleQuestionStatus}
            isMaturityModel={isMaturityModel}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
}
